// # Public routes configuration
import React from 'react';
import { Route } from 'react-router-dom';

// # Import guide components
import AnkiGuide from '../general/extra_content/guide/guide_anki';
import ExamDayGuide from '../general/extra_content/guide/guide_exam_day';
import LibrariesGuide from '../general/extra_content/guide/guide_libraries';
import QuestionsGuide from '../general/extra_content/guide/guide_questions';
import RotationsGuide from '../general/extra_content/rotations/rotation_main';

// # Import profile routes
import profileRoutes from './visitor_routes/profile_routes';

// # Define public routes
const publicRoutes = [
  // # Guide routes
  <Route key="guide-anki" path="/guide/anki" element={<AnkiGuide />} />,
  <Route key="guide-exam-day" path="/guide/exam-day" element={<ExamDayGuide />} />,
  <Route key="guide-libraries" path="/guide/libraries" element={<LibrariesGuide />} />,
  <Route key="guide-questions" path="/guide/questions" element={<QuestionsGuide />} />,
  <Route key="guide-rotations" path="/guide/rotations" element={<RotationsGuide />} />,
  
  // # Profile routes - map each profile route to a Route component
  ...profileRoutes.map(route => (
    <Route 
      key={`profile-route-${route.path}`} 
      path={route.path} 
      element={route.element} 
    />
  )),
  
  // # Add other public routes here
];

export default publicRoutes;
